import { Component, Input, OnInit } from '@angular/core';
import { StatusBadgeColourScheme } from '../status-badge-constants';
import { unifiedBallotStatusConnectEnum } from '../../../../shared/constants/unified-ballot-status-constants';
import { ConnectEnumUtility } from '../../../../shared/utilities/connect-enum-utility';
import { UnifiedBallotStatus } from '../../../../shared/enums/unified-ballot-status-enum';

@Component({
    selector: 'app-ballot-status-badge',
    templateUrl: './ballot-status-badge.component.html',
    styleUrl: './ballot-status-badge.component.scss',
    standalone: false
})
export class BallotStatusBadgeComponent implements OnInit {
  @Input() statusId?: UnifiedBallotStatus;
  badgeColourScheme: StatusBadgeColourScheme = StatusBadgeColourScheme.grey;
  StatusName?: string;

  ngOnInit(): void {
    this.badgeColourScheme = this.getBadgeColourScheme(this.statusId);
    this.StatusName = ConnectEnumUtility.getStatusDisplayTextById<UnifiedBallotStatus>(unifiedBallotStatusConnectEnum, this.statusId);
  }

  getBadgeColourScheme(statusId: number | undefined): StatusBadgeColourScheme{
    if(statusId === undefined) {
      return StatusBadgeColourScheme.grey;
    }

    switch(statusId) {
      case UnifiedBallotStatus.created:
      case UnifiedBallotStatus.scheduled:
        return StatusBadgeColourScheme.grey;

      case UnifiedBallotStatus.openForVoting:
        return StatusBadgeColourScheme.Green;

      case UnifiedBallotStatus.closedForVoting:
        return StatusBadgeColourScheme.Red;

      case UnifiedBallotStatus.finalised:
        return StatusBadgeColourScheme.grey;

      case UnifiedBallotStatus.pendingClosure:
        return StatusBadgeColourScheme.warningOrange;

      case UnifiedBallotStatus.deferred:
      case UnifiedBallotStatus.onHold:
          return StatusBadgeColourScheme.grey;

      case UnifiedBallotStatus.pendingFinalisedApproval:
          return StatusBadgeColourScheme.activeBlue;

      case UnifiedBallotStatus.reviewComplete:
          return StatusBadgeColourScheme.grey;
      default:
        return StatusBadgeColourScheme.grey;
    }
  }

}
